import ActivityPhaseList from './ActivityPhaseList'
import ThoughtStep from './thoughtchain/ThoughtStep'
import TimelineRow from './TimelineRow'

export default function OrphanSteps({
  rows,
  hasGroups,
  streaming,
  citations = [],
}) {
  if (!rows.length) return null
  if (!hasGroups) {
    return (
      <ActivityPhaseList
        rows={rows}
        streaming={streaming}
        citations={citations}
      />
    )
  }
  return (
    <ThoughtStep
      category="tasks"
      title="Other steps"
      streaming={streaming}
    >
      {rows.map((row) => (
        <TimelineRow
          key={row.id}
          row={row}
          streaming={streaming}
          nested={hasGroups}
        />
      ))}
    </ThoughtStep>
  )
}
